<template>
  <el-container class="container">
    <el-header class="header">
      <Header />
    </el-header>
    <div class="main">
      <router-view />
    </div>
  </el-container>
</template>

<script>
import Header from '@/components/main/header';
export default {
  name: 'apply',
  components: {
    Header,
  },
  data() {
    return {
      // menuList: [],
    };
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.container {
  background-color: #f8f8f8;
  font-size: @base-font-size;
  .box_column_center();
  .header {
    position: fixed;
    z-index: 999;
    min-width: 100vw;
    padding: 0 !important;
    background-color: @bg-white;
    .box_row_column_center();
  }
}
.main {
  padding-top: 60px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  .box_column();
  margin-top: 15px;
}
</style>
